import Route from '@ember/routing/route';
import { inject as service } from '@ember/service';
import type SensorService from '../services/sensor';
import type ModelService from '../services/model';
import type RouterService from '@ember/routing/router-service';
import PhotodiodeController from '../controllers/photodiode';
import ApplicationController from '../controllers/application';

type Transition = ReturnType<RouterService['transitionTo']>;

export default class PhotodiodeRoute extends Route {
  @service('model') declare modelService: ModelService;
  @service('sensor') declare sensorService: SensorService;

  beforeModel(/* transition */): Promise<void> {
    if (this.sensorService.sensors) {
      return this.sensorService.sensors.then((sensors) => {
        if (sensors !== null) {
          this.modelService.sensors = sensors;
          this.modelService.limits = this.sensorService.limits;
          this.modelService.shoppingCartUrl = this.sensorService.shoppingCartUrl;
        }
        return Promise.resolve();
      });
    }
    return Promise.resolve();
  }

  setupController(controller: PhotodiodeController, model: ModelService, transition: Transition): void {
    super.setupController(controller, model, transition);
    /* eslint-disable ember/no-controller-access-in-routes */
    let appController = <ApplicationController>this.controllerFor('application');
    controller.updateEnabledTabs = appController.updateEnabledTabs;
    controller.setupDialogFunctions(appController);
    /* eslint-disable ember/no-controller-access-in-routes */
  }
}
